export type PermissionCode = string;

export interface PermissionSubject {
  permissions?: PermissionCode[] | null;
}

const permissionSet = (subject?: PermissionSubject | PermissionCode[] | null): Set<PermissionCode> => {
  const permissions = Array.isArray(subject) ? subject : subject?.permissions;
  return new Set(permissions || []);
};

export const hasPermission = (
  subject: PermissionSubject | PermissionCode[] | null | undefined,
  permission: PermissionCode
): boolean => permissionSet(subject).has(permission);

export const hasAnyPermission = (
  subject: PermissionSubject | PermissionCode[] | null | undefined,
  permissions: PermissionCode[]
): boolean => permissions.some((permission) => hasPermission(subject, permission));

export const hasAllPermissions = (
  subject: PermissionSubject | PermissionCode[] | null | undefined,
  permissions: PermissionCode[]
): boolean => permissions.every((permission) => hasPermission(subject, permission));
